(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["v2m-dynamic-infographic"] && !Shopify.designMode) return;
  try {
    
(function () {
  var STEP_DURATION = 2000;

  function initInfographic(sectionEl) {
    var arcSegs   = sectionEl.querySelectorAll('.v2m-arc-seg');
    var nodes     = sectionEl.querySelectorAll('.v2m-node');
    var pill      = sectionEl.querySelector('.v2m-pill');
    var stepItems = sectionEl.querySelectorAll('.v2m-step-item');
    var wrapper   = sectionEl.querySelector('.v2m-infographic-wrapper');

    if (!nodes.length) return;

    var totalSteps  = nodes.length;
    var currentStep = 0;
    var timer       = null;
    var ioDebounce  = null;
    var started     = false;
    var reduced     = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Collecter couleurs + descriptions depuis les data-attributes
    var steps = Array.from(nodes).map(function (n) {
      return { color: n.dataset.color, desc: n.dataset.desc };
    });

    // Retirer le fallback CSS statique
    wrapper.classList.add('js-ready');

    function goToStep(n) {
      // Nœuds
      nodes.forEach(function (node) { node.classList.remove('is-active'); });
      nodes[n].classList.add('is-active');

      // Liste mobile
      stepItems.forEach(function (item) { item.classList.remove('is-active'); });
      if (stepItems[n]) stepItems[n].classList.add('is-active');

      // Segments d'arc — activer le bon segment via classe CSS
      arcSegs.forEach(function (seg, i) {
        seg.classList.toggle('is-active', i === n);
      });

      // Pill
      if (pill) {
        pill.textContent = steps[n].desc;
        pill.style.setProperty('--pill-color', steps[n].color);
      }

      currentStep = n;
    }

    function nextStep() {
      goToStep((currentStep + 1) % totalSteps);
    }

    function startTimer() {
      clearInterval(timer);
      timer = setInterval(nextStep, STEP_DURATION);
    }

    function stopTimer() {
      clearInterval(timer);
      timer = null;
    }

    // Init step 0
    goToStep(0);

    if (reduced) return;

    // Pause au survol (desktop)
    if (wrapper) {
      wrapper.addEventListener('mouseenter', stopTimer);
      wrapper.addEventListener('mouseleave', startTimer);
    }

    // Démarrage / arrêt selon la visibilité dans le viewport
    // Debounce de 150 ms pour éviter les cascades dues au scroll mobile
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        clearTimeout(ioDebounce);
        var entry = entries[entries.length - 1];
        ioDebounce = setTimeout(function () {
          if (entry.isIntersecting) {
            if (!started) { started = true; nextStep(); }
            startTimer();
          } else {
            stopTimer();
          }
        }, 150);
      }, { threshold: 0.25 });
      observer.observe(sectionEl);
    } else {
      startTimer();
    }
  }

  document.querySelectorAll('.v2m-dynamic-infographic').forEach(initInfographic);
})();

  } catch(e) { console.error(e); }
})();
})();
